<div class="border-b border-slate-200 px-5 py-4">
  <div class="flex items-center justify-between">
    <h4 class="text-lg font-semibold text-slate-900" id="modal-basic-title">
      Crear empresa
    </h4>
    <button
      type="button"
      class="rounded-lg border border-slate-300 px-2 py-1 text-slate-600 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="modal().dismiss('Cross click')"
    >
      <i class="bi bi-x"></i>
    </button>
  </div>
</div>
<div class="px-5 py-4">
  <form [formGroup]="formCrear" class="grid gap-4 md:grid-cols-12">
    <div class="md:col-span-6">
      <label for="ruc" class="mb-1 block text-sm font-medium text-slate-700"
        >RUC <span class="text-red-600">*</span></label
      >
      <input
        type="text"
        formControlName="ruc"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        id="ruc"
        placeholder="Ingrese el RUC"
      />
      <span class="mt-1 block text-xs text-slate-500">11 dígitos</span>
    </div>
    <div class="md:col-span-6">
      <label for="nombre" class="mb-1 block text-sm font-medium text-slate-700"
        >Nombre <span class="text-red-600">*</span></label
      >
      <input
        type="text"
        formControlName="nombre"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        id="nombre"
        placeholder="Ingrese el nombre de la empresa"
      />
      <span class="mt-1 block text-xs text-slate-500">Razon social</span>
    </div>
    <div class="md:col-span-6">
      <label for="email" class="mb-1 block text-sm font-medium text-slate-700"
        >Correo electrónico <span class="text-red-600">*</span></label
      >
      <input
        type="email"
        formControlName="email"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        placeholder="prueba@correo.com"
      />
    </div>
    <div class="md:col-span-6">
      <label for="contra" class="mb-1 block text-sm font-medium text-slate-700"
        >Contraseña <span class="text-red-600">*</span></label
      >
      <input
        type="password"
        formControlName="contra"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        placeholder="Ingrese la contraseña"
        autocomplete="new-password"
      />
      <small class="mt-1 block text-xs text-slate-500"
        >Al menos 8 caracteres, una letra mayúscula, un número y un
        símbolo.</small
      >
    </div>
    <div class="md:col-span-6">
      <label
        for="sucursal_nombre"
        class="mb-1 block text-sm font-medium text-slate-700"
        >Sucursal principal <span class="text-red-600">*</span></label
      >
      <input
        type="text"
        formControlName="sucursal_nombre"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        id="sucursal_nombre"
        placeholder="Sucursal Principal"
      />
    </div>
    <div class="md:col-span-6">
      <label
        for="sucursal_codigo"
        class="mb-1 block text-sm font-medium text-slate-700"
        >Código sucursal <span class="text-red-600">*</span></label
      >
      <input
        type="text"
        formControlName="sucursal_codigo"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        id="sucursal_codigo"
        placeholder="PRINCIPAL"
      />
    </div>
    <div class="md:col-span-12">
      <label
        for="vencimiento"
        class="mb-1 block text-sm font-medium text-slate-700"
        >Fecha de Vencimiento <span class="text-red-600">*</span></label
      >
      <input
        type="date"
        formControlName="vencimiento"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        id="vencimiento"
      />
      <span class="mt-1 block text-xs text-slate-500"
        >Vencimiento de la licencia</span
      >
    </div>
  </form>
</div>
<div class="flex justify-end gap-2 border-t border-slate-200 px-5 py-4">
  <button
    type="button"
    class="rounded-lg bg-emerald-600 px-3 py-2 text-sm font-medium text-white transition hover:bg-emerald-500 disabled:cursor-not-allowed disabled:opacity-60"
    (click)="saveChanges()"
    [disabled]="formCrear.invalid"
  >
    Guardar
  </button>
  <button
    type="button"
    class="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
    (click)="modal().close('Save click')"
  >
    Cancelar
  </button>
</div>
